import React, {Component} from 'react';

import GroupModalForm from './GroupModalForm'
import {UUID_NULL} from '../constants/defaultValues'

class GroupChildLinkCreate extends Component {
  state = {
    visible: false
  };
  showModal = () => {
    this.setState({visible: true});
  };
  handleCancel = () => {
    this.setState({visible: false});
  };
  handleCreate = () => {
    const form = this.form;
    form.validateFields((err, values) => {
      if (err) {
        return;
      }
      const {ID, ParentID, Name, MoreInfo} = values
      const desc = MoreInfo.desc
        ? MoreInfo.desc
        : ""
      const jsonString = JSON.stringify({desc: desc})
      const info = btoa(unescape(encodeURIComponent(jsonString)))
      const group = {
        ID: ID,
        ParentID: ParentID,
        Name: Name,
        MoreInfo: info
      }
      this.props.onCreate(group)
      form.resetFields();
      this.setState({visible: false});
    });
  };
  saveFormRef = (form) => {
    this.form = form;
  };
  render() {
    const {parent, groups} = this.props
    const group = {
      ID: UUID_NULL,
      Name: ""
    }
    return (<span>
      <a onClick={this.showModal} role="button">Thêm địa bàn nhỏ</a>
      <GroupModalForm title="Thêm mới địa bàn nhỏ" group={group} parent={parent} groups={groups} ref={this.saveFormRef} visible={this.state.visible} onCancel={this.handleCancel} onSubmit={this.handleCreate}/>
    </span>);
  }
}

export default GroupChildLinkCreate;



// WEBPACK FOOTER //
// ./src/components/GroupChildLinkCreate.js